<template>
    <div class="wobuListContainerInbox" :class="{isFixedLeft: isInbox}">
        <div style="display: inline-block; height: 100%">

            <div id="inboxHeader" class="inboxHeader">
                <div class="posRelative">
                    <i class="is-hidden-desktop fa fa-chevron-left has-text-white is-pulled-left top17 left5  handCursor " @click="$parent.toggleInbox"></i>
                   <div class="is-inline-block inboxPlusAndLabel">
                        <div id="v-step-0" class="newSubBt2 is-inline-block" @click="toggleUrlBar" @dragover="openUrlBar" v-tooltip="'Add miimu'"><b >+</b></div>
                        <div :transfer-data="{listIndex: listIndex}" class="is-size-4 is-inline-block  has-text-grey top8 left12" >
                            <b>MIIMUS</b>
                        </div>
                   </div>
                </div>
               
    
                <div v-if="isInbox">
                   
                   
                    <div v-if="menuVisible" class="inboxMenu" @click="stopProp"> 

                        <input class="input searchTextInput left-5" type="text" v-model="terms"  @keyup.enter="localSearch"/>
                        <button class="button is-coolGreen is-small left-10 has-text-grey" style="z-index: 1" @click="localSearch"><i class="fa fa-search"></i></button>

                        <div class="bundleMenuItem top20" @click="toggleMultiple" >
                            <i class="fa fa-check is-size-6 handCursor sortControlButt" ></i>Multiple Select
                        </div>
                       
                    </div>
    
                    <div class="is-inline-block vTop" @click.prevent="showMenu" style="position: absolute; top: -2px; right: 10px" >
                        <div class="cardVEllipsis" :class="{cardDownTit: !$root.app.showImages}"><b>&vellip;</b></div>
                    </div>
                </div>
            </div>

          <!--   <button class="button  is-small  is-dark" style="position: absolute; top: 12px; right: 5px" @click="toggleMultiple">
               <i class="fa fa-check is-size-7 handCursor has-text-light top2" v-tooltip="'Multiple Select'"></i>
            </button> -->


            <div style="margin-top: 0" class="wobuList" :class="{inboxBG: isInbox}" >

                <drop v-show="showUrlBar" class="dropWrapper" @drop="handleDrop">
                   <!--  <div class="drop disable-selection"  id="v-step-1"><b>add<span >+</span></b></div> -->
                    <div  class="has-text-centered  urlPasteBlock" >
                       <!--  <textarea id="urlTextArea" placeholder="drag/drop, type or paste a url here" class="top5 dropUrlTextArea has-text-dark" @paste="doPaste" v-model="goUrl" @keyup.enter="go" rows="1"></textarea><br>  -->
                        <input type="text" id="urlTextArea" placeholder="drag/drop, type or paste a url here" class="top5 dropUrlTextArea has-text-dark" @paste="doPaste" v-model="goUrl" @keyup.enter="go" /><br> 
                    </div>
                </drop>

                
                
               <div class="top-10">
                   <div v-show="inMultiSelect">
                    <button class="button is-coolGreen is-small top30" @click="openMulti">MOVE/TAG</button>
                    <button v-show="inMultiSelect" class="button is-small is-dark top30 left10 " @click="selectAll">ALL</button>
                    <button v-show="inMultiSelect" class="button is-small is-dark top30 left5 " @click="unSelectAll">NONE</button>
                       
                        <div class="delete" style="position: absolute; right: 8px; transform: scale(1.2,1.2);" @click="toggleMultiple"></div>
                   </div>
                    <div v-for="(item, index) in conts.items" :key=index>
                        <url-card ref="cardRef"  v-bind="item" v-bind:listIndex="listIndex" v-bind:itemIndex="index" v-bind:theCardsIndex="item.cardsIndex"></url-card>
                    </div> 
                    <trans-drop-zone style="margin-left: 0" id="transDrop" v-bind:listIndex="listIndex" v-bind:itemIndex="info.items.length" ></trans-drop-zone>
               </div>
            </div>
        </div>
    </div>
</template>

<script>


    import UrlCard from './UrlCard.vue'
    import TransDropZone from './TransDropZone.vue'
    import ListThumbnail from './ListThumbnail.vue'
    import { Drag, Drop } from 'vue-drag-drop'
    import { AZEventBus } from '../components/AZEventBus'

    export default {
        name: 'inbox',
        components: {UrlCard, TransDropZone, ListThumbnail, Drag, Drop},
        props: {
            info: Object,
            listIndex: Number
        },
        data: function(){
            return {
                isInbox: false,
                dragging: false,
                showUrlBar: false,
                goUrl: '',
                inMultiSelect: false,
                multiSelections: [],
                pendingFullLoad: true,
                menuVisible: false,
                data: {isPublic: false},
                terms: '',
                offset: 20,
                observer: null
                
            }
        },
        created: function(){
            if(this.info.listName == 'Inbox')
                this.isInbox = true
        },

        mounted: function(){
            var self = this;
              if(this.info.items.length && !this.info.fullyLoaded ){ //
          
                    this.observer = new IntersectionObserver(function(entries) {
                    // isIntersecting is true when element and viewport are overlapping
                    // isIntersecting is false when element and viewport don't overlap
                    if(entries[0].isIntersecting === true){
  
                        self.observer.disconnect()
                        self.loadItems()
                    }
                    
                    }, { threshold: [0] });

                    AZEventBus.$on('closeAllMenus', this.closeAllMenusHandler)

                    setTimeout(function(){ 
                        if(self.$refs.cardRef && self.$refs.cardRef[19])
                            self.observer.observe(self.$refs.cardRef[19].$el);
                    }, 10)
                }
        },

        beforeDestroy: function(){
            var self = this;

            self.observer.disconnect()
            AZEventBus.$off('closeAllMenus', this.closeAllMenusHandler)
        },

        methods:{
            closeAllMenusHandler: function(msg){
                this.menuVisible = false
            },

            handleDragOver: function(data, event){
                if(data.type == 'list'){
                    this.dragging = true;
                }
            },
            doDrop: function(data, event){
            /* if(data.type == 'list'){
                    var item;
                    if(data.kind == 'listThumbnail'){                
                        //listThumbnail is being dropped
                        item = this.$root.app.init.lists[data.listIndex].items[data.itemIndex];
                        //insert
                        this.$root.app.init.lists.splice(this.listIndex, 0, item);
                        //remove
                        this.$root.app.init.lists[data.listIndex].items.splice(data.itemIndex, 1);
                    } else {
                        //list is being dropped
                        item = this.$root.app.init.lists[data.listIndex];
                        //insert
                        this.$root.app.init.lists.splice(this.listIndex, 0, item);
                        //remove
                        if(data.listIndex < this.listIndex)
                            this.$root.app.init.lists.splice(data.listIndex, 1);
                        else
                            this.$root.app.init.lists.splice(data.listIndex+1, 1);
                    }
                    this.dragging = false;
                } */
            },
            sort: function(){
                this.info.items.sort(function(a,b){ return a.p - b.p})
            },
            handleDrop(data, event) {
                event.preventDefault();
                this.$root.app.doShowModal('editModal', {url: this.sanitizeURL(event.dataTransfer.getData('URL'))})
                this.showUrlBar = false
                //console.log(event.dataTransfer.getData('URL'));
            },
            toggleUrlBar: function(){
                this.$parent.$parent.nextTourStep();
                this.showUrlBar = !this.showUrlBar
                setTimeout(function(){
                    document.getElementById('urlTextArea').focus()
                },100)
                
            },
            sanitizeURL: function(url){
                var newURL = url.split('://');

                if (newURL.length == 1){
                return  'http://' + url
                }

                return url
            },
            go: function(){
              
                if(this.goUrl == ''){
                    return
                } else if(this.$root.app.$tours['myTour'].isRunning){
                    this.$parent.$parent.nextTourStep()
                }  

                if(this.goUrl.replace(/[\n\r]+/g, '') == '') {
                    this.goUrl = ''
                    return
                }
                var obj = {
                    dataTransfer: {}
                };
                obj.dataTransfer.url = this.goUrl.replace(/[\n\r]+/g, '')
                obj.preventDefault = function(){}
                obj.dataTransfer.getData = function(){
                    return this.url.replace(/[\n\r]+/g, '');
                }
                this.goUrl = ''
                this.handleDrop({}, obj);
                
            },
            doPaste: function(){
                var self = this;
                setTimeout(self.go, 10)
            },
            openMulti: function(){
                var self = this

                if(this.multiSelections.length == 0){
                    this.$root.app.showModalOK({message: 'You must select at least one miimu'})
                    return
                }
                
                var ids = []
                this.multiSelections.forEach(e => {
                    ids.push(e.id)
                })

                ids.forEach((e, i) => {
                    var found = false
                    for(var x=0; x < self.conts.items.length; x++){
                        if(self.conts.items[x].id == e){
                            found = true
                            break
                        }
                    }

                    if(!found){
                        self.multiSelections.splice(i, 1)
                    }
                })

                this.$root.app.doShowModal('ModalMulti', {message: '', items: this.multiSelections, callBack: this.closeMulti, selectedId: this.conts.id, selectedAliasId: this.conts.id, collabId: this.conts.collabId, forceRemove: true, fromInbox: this.conts.id })
            },

            closeMulti: function(){
                this.$refs.cardRef.forEach(b => {
                    b.isSelected = false
                })

                this.inMultiSelect = false
                this.multiSelections.splice(0)
            },
            toggleMultiple: function(){
                this.menuVisible = false;
                this.inMultiSelect = !this.inMultiSelect
            },
            addToMulti: function(obj){
                for(var x=0; x < this.multiSelections.length; x++){
                    if(this.multiSelections[x].id == obj.id){
                        return
                    }
                }

                this.multiSelections.push(obj)
                
            },

            localSearch: function(s){
                this.menuVisible = false
                var p = {
                    id: this.aliasTgtid || this.conts.id,
                    collabId: this.conts.collabId,
                    listName: this.conts.listName,
                    localBundle: this,
                    terms: this.terms
                }
                this.$parent.$refs.searchComp.localPayload = p
                this.$parent.$refs.searchComp.isLocal = true
                this.$parent.$refs.searchComp.inputOpen = true
                this.$parent.$refs.searchComp.doLocalSearch()
                this.terms = ''

               /*  var p = {
                    id: this.aliasTgtid || this.conts.id,
                    collabId: this.conts.collabId,
                    listName: this.conts.listName,
                    localBundle: this
                }
                this.$parent.$refs.searchComp.localPayload = p
                this.$parent.$refs.searchComp.isLocal = true
                this.$parent.$refs.searchComp.inputOpen = true */
                
            },

            removeFromMulti: function(obj){
                this.multiSelections = this.multiSelections.filter(e => {
                    return e.id != obj.id
                })
            },

            openUrlBar: function(){
                this.showUrlBar = true;
            },

            showMenu: function(){
                event.stopPropagation()
                this.menuVisible = true
            },

            stopProp: function(event){
                event.stopPropagation();
            },

            loadItems: function(callBack, selections){
           
                    var self = this;

                    function w(d){
                    az.addRemSpinner(false, 'id', 'transDrop')
                    var cards = d.response.cards

                    for(var i = 0; i < cards.length; i++){
                        
                            var already = self.$root.app.cards.findIndex(e => {
                                return e.id == cards[i].id
                            })

                        /*  if (already != -1)
                                continue */

                            var ind;
                            var parents = JSON.parse(cards[i].parents) || []
                            cards[i].parents = JSON.parse(cards[i].parents)
                            cards[i].tags = JSON.parse(cards[i].tags) || []

                            if(self.$root.app.userAttrs.sub != cards[i].id_cog){
                            cards[i].myCard = false
                            } else {
                            cards[i].myCard = true
                            }

                            //*push or splice
                            if(already > -1){
                                self.$root.app.cards.splice(already, 1, cards[i])
                                cards[i].cardsIndexForInject = already
                            } else {
                                self.$root.app.cards.push(cards[i])  
                                cards[i].cardsIndexForInject = self.$root.app.cards.length - 1
                            }

                            
                            
                        

                            var arrOfParentIds = []
                            for(var x = 0; x < parents.length; x++){

                            ind = self.$root.app.bundles.findIndex(e => {
                                return e.id == parents[x].id
                            })



                            //*push or splice
                            if(ind != -1){
                                arrOfParentIds.push(parents[x].id)
                                /* if(!already){
                                    self.$root.app.bundles[ind].items.push({id: cards[i].id, p: parents[x].p, cardsIndex: self.$root.app.cards.length - 1, entryId: parents[x].entryId, id_cog: cards[i].id_cog})
                                } else { */
                                    //get index of item
                                    var itemIndex = self.$root.app.bundles[ind].items.findIndex(ii => {
                                        return ii.id == cards[i].id;
                                    })
                                    
                                    
                                    if(itemIndex > -1){
                                        self.$root.app.bundles[ind].items.splice(itemIndex, 1, {id: cards[i].id, p: parents[x].p, cardsIndex: already, entryId: parents[x].entryId, id_cog: cards[i].id_cog})
                                    } else {
                                        self.$root.app.bundles[ind].items.push({id: cards[i].id, p: parents[x].p, cardsIndex: cards[i].cardsIndexForInject, entryId: parents[x].entryId, id_cog: cards[i].id_cog})
                                    }
                                    
                                //}  
                            }
                                
                            }

                        


                            for(var bdel = 0; bdel < self.$root.app.bundles.length; bdel++){
                                var b = self.$root.app.bundles[bdel]
                                

                                for(var ddel = 0; ddel < b.items.length; ddel++){
                                    var idd = b.items[ddel].id
                                
                                    if(!arrOfParentIds.includes(b.id) && idd == cards[i].id){
                                        b.items.splice(ddel, 1)
                                        break
                                    }
                                }
                            }

                            self.conts.items.sort(function(a,b){ return a.p - b.p});




                            //ratings

                        

                            d.response.ratings.forEach(e => {
                                self.$root.app.ratings.push(e)
                            })

                            d.response.ratingsAvg.forEach(e => {
                                self.$root.app.ratingsAvg.push(e)
                            })

                            let cd = self.$root.app.cards[cards[i].cardsIndexForInject]; 

                        

                            let myRatings = []
                            for(var l=0; l < d.response.ratings.length; l++){
                                if(d.response.ratings[l].id_CARDS == cd.id){
                                    myRatings.push({collabId: d.response.ratings[l].id_COLLAB, rating:  d.response.ratings[l].rating})
                                }
                            }

                            let avgRatings = []
                            for(l=0; l < d.response.ratingsAvg.length; l++){
                                if(d.response.ratingsAvg[l].id_CARDS == cd.id){
                                    avgRatings.push({collabId: d.response.ratingsAvg[l].id_COLLAB, rating:  d.response.ratingsAvg[l].rating})
                                }
                            }

                            let memAvg = []
                            for(l=0; l < d.response.memberAvg.length; l++){
                                if(d.response.memberAvg[l].id_CARDS == cd.id){
                                    memAvg.push({collabId: d.response.memberAvg[l].id_COLLAB, rating:  d.response.memberAvg[l].rating})
                                }
                            }

                            cd.myRatings = myRatings;
                            cd.avgMemRatings = memAvg;
                            cd.avgRatings = avgRatings;

                            

                        }  


                       
                        
                        let toCh = self.$root.app.bundles.find(e => {
                            return e.id == self.conts.id
                        })
                      

                        toCh.itemsLoaded = true
                        //toCh.fullyLoaded = true
                        toCh.forceLoadFromInject = false

                        let arr = d.response.tagUniverse
                        let tu = {}
                        arr.forEach(e => {
                            tu[e.tag] = e.tag
                        })

                        
                       
                        arr.forEach(e => {
                            self.$root.app.tagUniverse[e] = e
                        })
                        //console.log(self.$root.app.tagUniverse)


                        

                        self.pendingFullLoad = false

                        

                        
                        if(callBack){
                             callBack(selections)
                        } else {
                            setTimeout(function(){ 
                               
                                if(self.$refs.cardRef && self.$refs.cardRef[19 + self.offset])
                                    self.observer.observe(self.$refs.cardRef[19 + self.offset].$el);
                                    self.offset += 20
                            }, 10)
                        }

                        //if no callback means its inbox or regular bundle
                        //Increase offset for query and attach observer to new card
                        
                        
                    }

                    function n(){
                         az.addRemSpinner(false, 'id', 'transDrop')
                    }
                    
                    let al = this.conts.aliasTgtId ? this.conts.aliasTgtId : this.conts.id;

                    az.addRemSpinner(true, 'id', 'transDrop')
                    this.$root.app.apiClient.get('subs/data/bundle/' + al + '/' + this.offset, {}, w, n)

                },


            startSelectFromSearch(arr){
                this.loadItems(this.selectFromSearch(arr))
            },

            selectFromSearch: function(arr){

                var self = this
                this.inMultiSelect = true
                this.showControlsMenu = false

                this.multiSelections.splice(0);
                this.$refs.cardRef.forEach(e => {
                    if(e.itemIndex != undefined){
                        if(arr.includes(e.id)){
                            e.isSelected = true
                            self.multiSelections.push(e.item)
                        } else {
                            e.isSelected = false
                        }
                    }
                })

            },


            selectAll: function(){
    
                var arr = []
                this.conts.items.forEach(e => {
                    arr.push(e.id)
                })

                this.selectFromSearch(arr)
            },

            unSelectAll: function(){
                this.multiSelections.splice(0);
                this.$refs.cardRef.forEach(e => {
                    if(e.itemIndex != undefined){
                        e.isSelected = false
                    }
                })
            
            }
        },
        computed:{
            conts: function(){ 
                return this.info || {items: []}
            }
        },

        watch: {
            conts: {
                handler(val){
                   if(this.conts.items.length < 19 && this.pendingFullLoad){
                       this.loadItems()
                   } 
                },
                deep: true
            }
        }

       
    }
</script>